<template>
  <div class="app-data-filter-input-range">
    <div class="app-data-filter-input-range__track">
      <div class="app-data-filter-input-range__fill" :style="fillStyle" />
      <input
        type="range"
        :min="min"
        :max="max"
        :step="step"
        :value="from"
        :aria-label="labelFrom"
        @input="onFrom"
        @change="emit"
      />
      <input
        type="range"
        :min="min"
        :max="max"
        :step="step"
        :value="to"
        :aria-label="labelTo"
        @input="onTo"
        @change="emit"
      />
    </div>
    <div class="app-data-filter-input-range__values">
      <slot :from="from" :to="to">{{ from }} – {{ to }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    min: { type: Number, required: true },
    max: { type: Number, required: true },
    step: { type: Number, default: 1 },
    value: { type: Array, default: () => [] }, // [from, to]
    labelFrom: { type: String, default: 'Min value' },
    labelTo: { type: String, default: 'Max value' },
  },

  data() {
    return {
      from: this.value[0] || this.min,
      to: this.value[1] || this.max,
    };
  },

  computed: {
    fillStyle() {
      const range = this.max - this.min;
      return {
        left: `${((this.from - this.min) / range) * 100}%`,
        right: `${((this.max - this.to) / range) * 100}%`,
      };
    },
  },

  watch: {
    value([from, to]) {
      this.from = from || this.min;
      this.to = to || this.max;
    },
  },

  methods: {
    onFrom(e) {
      this.from = Math.min(+e.target.value, this.to);
      e.target.value = this.from;
    },
    onTo(e) {
      this.to = Math.max(+e.target.value, this.from);
      e.target.value = this.to;
    },
    emit() {
      this.$emit('input', [this.from, this.to]);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

$thumb-color: vars.$c-dark-gray;

@mixin thumb {
  width: 18px;
  height: 18px;
  border: 2px solid $thumb-color;
  border-radius: 50%;
  background: vars.$c-total-white;
  pointer-events: auto;
}

.app-data-filter-input-range {
  &__track {
    position: relative;
    height: 4px;
    margin: 12px 0;
    background: vars.$c-gray-e0;
    border-radius: 2px;
  }

  &__fill {
    position: absolute;
    top: 0;
    bottom: 0;
    background: $thumb-color;
  }

  &__values {
    font-size: 16px;
  }

  input[type='range'] {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    margin: 0;
    transform: translateY(-50%);
    background: none;
    pointer-events: none;
    -webkit-appearance: none;
    appearance: none;

    &::-webkit-slider-thumb {
      @include thumb;
      -webkit-appearance: none;
    }

    &::-moz-range-thumb {
      @include thumb;
    }
  }
}
</style>
